import { createContext, useContext } from 'react';

type FocusFrameContextValue = {
  hasMountedLayout: boolean;
  setHasMountedLayout(hasMountedLayout: boolean): void;
};

export const FocusFrameContext = createContext<FocusFrameContextValue>({
  hasMountedLayout: false,
  setHasMountedLayout: () => undefined,
});

export function useFocusFrame() {
  return useContext(FocusFrameContext);
}

export const FocusLayoutAnimationContext = createContext(true);

export function useInitialAnimation<T>(initial: T) {
  return useContext(FocusLayoutAnimationContext) ? initial : false;
}
